.action-container {
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;
  margin: 1.6rem 0;
}

.action {
  all: unset;

  color: var(--color-primary-crayola);
  font-size: 1.4rem;
  font-weight: 400;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
